import Vue from 'vue'
import Router from 'vue-router'
// import storage from '@/util/storage'

const Home = resolve => require(['@/views/Home'], resolve)
const Product = resolve => require(['@/views/Product'], resolve)
const ProductSearch = resolve => require(['@/views/ProductSearch'], resolve)
const ProductDetail = resolve => require(['@/views/ProductDetail'], resolve)
const Project = resolve => require(['@/views/Project'], resolve)
const ProjectDetail = resolve => require(['@/views/ProjectDetail'], resolve)
const ProjectEdit = resolve => require(['@/views/admin/ProjectEdit'], resolve)
const Account = resolve => require(['@/views/Account'], resolve)
const Server = resolve => require(['@/views/Server'], resolve)
const Lock = resolve => require(['@/views/Lock'], resolve)
const Article = resolve => require(['@/views/Article'], resolve)
const ArticleDetail = resolve => require(['@/views/ArticleDetail'], resolve)
const All = resolve => require(['@/views/All'], resolve)
const Github = resolve => require(['@/views/Github'], resolve)

const ProductVersion = resolve => require(['@/views/ProductVersion'], resolve)
const ProjectVersionEdit = resolve => require(['@/views/ProjectVersionEdit'], resolve)

const Admin = resolve => require(['@/views/admin/Home'], resolve)
const AdminProject = resolve => require(['@/views/admin/Project'], resolve)
// 产品
const AdminProduct = resolve => require(['@/views/admin/Product'], resolve)
const ProductEdit = resolve => require(['@/views/admin/ProductEdit'], resolve)
const AdminProductDetail = resolve => require(['@/views/admin/ProductDetail'], resolve)
// 需求
const AdminRequirement = resolve => require(['@/views/admin/Requirement'], resolve)
const RequirementEdit = resolve => require(['@/views/admin/RequirementEdit'], resolve)
// 需求来源
const RequirementSource = resolve => require(['@/views/admin/RequirementSource'], resolve)
const RequirementSourceEdit = resolve => require(['@/views/admin/RequirementSourceEdit'], resolve)
// 模块
const AdminModule = resolve => require(['@/views/admin/Module'], resolve)
const AdminModuleEdit = resolve => require(['@/views/admin/ModuleEdit'], resolve)
// bug
const AdminBug = resolve => require(['@/views/admin/Bug'], resolve)
const BugEdit = resolve => require(['@/views/admin/BugEdit'], resolve)

const OauthCallback = resolve => require(['@/views/oauth/Callback'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/oauth/callback',
        component: OauthCallback
    },
    {
        path: '/',
        redirect: '/products'
        // component: Home
    },
    {
        path: '/projects',
        component: Home
    },
    {
        path: '/articles',
        component: Article
    },
    {
        path: '/articles/:id',
        component: ArticleDetail
    },
    {
        path: '/products',
        component: Product
    },
    {
        path: '/product/search',
        component: ProductSearch
    },
    {
        path: '/products/:id',
        component: ProductDetail
    },
    {
        path: '/products/:id/versions',
        component: ProductVersion
    },
    {
        path: '/products/:id/version',
        component: ProjectVersionEdit
    },

    {
        path: '/admin/products/:id',
        component: AdminProductDetail
    },
    {
        path: '/product/add',
        component: ProductEdit
    },
    {
        path: '/lock',
        component: Lock
    },
    {
        path: '/all',
        component: All
    },
    {
        path: '/projects',
        component: Project,
        meta: {
            auth: true
        }
    },
    {
        path: '/projects/:id',
        component: ProjectDetail,
        meta: {
            auth: true
        }
    },
    {
        path: '/project/add',
        component: ProjectEdit
    },
    {
        path: '/accounts',
        component: Account,
        meta: {
            auth: true
        }
    },
    {
        path: '/servers',
        component: Server,
        meta: {
            auth: true
        }
    },
    {
        path: '/github',
        component: Github
    },
    {
        path: '/admin2',
        component: Admin
    },
    {
        path: '/admin/projects',
        component: AdminProject
    },
    {
        path: '/projects/:id/edit',
        component: ProjectEdit
    },
    // 需求
    {
        path: '/admin/products/:id/requirements',
        component: AdminRequirement
    },
    {
        path: '/requirement/add',
        component: RequirementEdit
    },
    {
        path: '/requirements/:id/edit',
        component: RequirementEdit
    },
    // 模块
    {
        path: '/admin/products/:id/modules',
        component: AdminModule
    },
    {
        path: '/module/add',
        component: AdminModuleEdit
    },
    {
        path: '/modules/:id/edit',
        component: AdminModuleEdit
    },
    {
        path: '/admin/products/:id/bugs',
        component: AdminBug
    },
    {
        path: '/bugs/:id/edit',
        component: BugEdit
    },
    {
        path: '/bug/add',
        component: BugEdit
    },
    {
        path: '/admin/requirement_sources',
        component: RequirementSource
    },
    {
        path: '/admin/requirement_sources/:id/edit',
        component: RequirementSourceEdit
    },
    {
        path: '/admin/requirement_source/add',
        component: RequirementSourceEdit
    },
    {
        path: '/admin/products',
        component: AdminProduct
    },
    {
        path: '/products/:id/edit',
        component: ProductEdit
    }
]

let router = new Router({
    mode: 'history',
    routes: routes
})

// router.beforeEach((to, from, next) => {
//     if (/lock/.test(to.path)) {
//         if (storage.get('lock_password')) {
//             router.push('/')
//         } else {
//             next()
//         }
//     } else if (to.matched.some(record => record.meta.auth)) {
//         window.redirect = encodeURIComponent(to.path)
//         // let redirect = encodeURIComponent(to.path)
//         let redirect = to.path
//         if (storage.get('lock_password')) {
//             next()
//         } else {
//             router.push({path: '/lock', query: {redirect: redirect}})
//         }
//         //
//         // if (localStorage.mytoken) {
//         //     next()
//         // } else {
//         //     router.push({path: '/login', query: {redirect: redirect}})
//         // }
//     } else {
//         next()
//     }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js